<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Special Events
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Special Events experienced a moderate decline in revenue by 3.5% (from $22.1m in 2018 to $21.3m in 2019) despite a significant growth in attendance (by 152.9% from 0.2m in 2018 to 0.4m in 2019). </p>
          <p>This was primarily attributed to the decline in the average ticket price by 53.1% (from $152.70 in 2018 to $71.68 in 2019) which may be explained by the special events presented as part of the Commonwealth Games in Brisbane in 2018. The top events in this category in 2019 were the <em>Royal Edinburgh Military Tattoo</em>, <em>Life the Show</em> and <em>Psychic Medium: John Edward</em>.</p>
          <p>Bans on mass gatherings, border closures and density limits introduced as part of COVID-19 restrictions resulted in a decline in revenue (by 78.2% to $4.6m) and a decline in attendance (by 61.3% to 0.2m) in 2020. The average ticket price declined by 22.7% (to $55.40), which further contributed to the decline in revenue. Major events in this category in 2020 were <em>Cuban Club</em>, <em>Fire Aid</em>, <em>RuPaul’s Drag Race</em> and <em>Heaps Gay Planet Xtra Mardi Pardi</em>. </p>
          <p>NSW accounted for 81.2% of the overall market share in revenue and 67.3% of the overall market share in attendance in this category in 2019. </p>
        </div>
        <div class="sixcol last">
          <p>In 2020, WA and QLD accounted for the largest market share in revenue in this category, with 38.9% and 30.1% respectively. WA and NSW accounted for the largest market share in attendance in this category, with 24.9% and 24.8% respectively, of the overall market share. </p>
          <p>In 2019, NT experienced the highest y-o-y growth in revenue (223.7%) and fourth highest y-o-y growth in attendance (143.8%). However, its impact was minimal as it represented only 0.1% in revenue and 0.1% in attendance of the overall market share in this category. NSW experienced the second highest y-o-y growth in revenue (157.0%) and the highest y-o-y growth in attendance (452.9%), largely attributable to the <em>Royal Edinburgh Military Tattoo</em>, which was exclusively staged in Sydney.</p>
          <p>In 2020, WA experienced the highest y-o-y growth in revenue (131.5%) and the second highest y-o-y growth in attendance (80.5%), primarily due to <em>Fire Aid</em>.</p>
          <p>The Special Events category is particularly variable as it is dependent on whether performances that cannot be classified into other categories take place.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>CanbEurovision 2019</em>, Canberra Theatre Centre, Photo Credit: Martin Ollmann</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [96.706, 89.357, 82.144, 117.204, 10.325, 23.602, 31.45, 15.8, 4.25, 6.03, 10.984, 20.341, 29.311, 5.05, 22.115, 21.352, 4.644],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [3.125, 2.992, 2.626, 3.453, 0.375, 0.559, 0.527, 0.37, 0.091, 0.113, 0.21, 0.557, 0.185, 0.137, 0.17, 0.431, 0.167],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 81.2],
            ["VIC", 6.3],
            ["QLD", 3.8],
            ["WA", 3.7],
            ["SA", 2.5],
            ["ACT", 2.1],
            ["TAS", 0.3],
            ["NT", 0.1]
          ],
          attendance: [
            ["NSW", 67.3],
            ["VIC", 10.1],
            ["QLD", 11.7],
            ["WA", 5.3],
            ["SA", 3.1],
            ["ACT", 2.1],
            ["TAS", 0.2],
            ["NT", 0.1]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 15.5],
            ["VIC", 3.7],
            ["QLD", 30.1],
            ["WA", 38.9],
            ["SA", 5.9],
            ["ACT", 4.6],
            ["TAS", 0.4],
            ["NT", 0.8]
          ],
          attendance: [
            ["NSW", 24.8],
            ["VIC", 19.3],
            ["QLD", 17.2],
            ["WA", 24.9],
            ["SA", 8.9],
            ["ACT", 3.5],
            ["TAS", 0.5],
            ["NT", 1.0]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("../../../assets/img/2019/CanbEurovision-2019,-Canberra-Theatre-Centre,-Martin-Ollmann_SFW.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
